'use es6';

import { Component } from 'react';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Button } from 'foundations-components/transitional/components/Button';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { Text } from 'foundations-components/components/Text';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { View } from 'foundations-components/components/View';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { MediaObject } from 'foundations-components/transitional/components/MediaObject';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { HR } from 'foundations-components/transitional/components/HR';
import { CONNECT_INBOX_STEP, OPT_INTO_AUTOMATION_STEP, EMAIL_INPUT_STEP } from 'InboxConnectUtils/constants/InboxConnectStepKeys';
import StepInterface from './StepInterface';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LANG_ROUTE = 'InboxConnectUtils.wizard.optIntoAutomation';
class OptIntoAutomationStep extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isChecked: false
    };
  }
  componentDidMount() {
    this.props.trackingClient.trackStepView(OPT_INTO_AUTOMATION_STEP);
    if (this.props.hideOptInToAutomationStep) {
      this.handleButtonClick();
    }
  }
  handleButtonClick() {
    const {
      setShownStep,
      isAllowCustomEmailInput,
      emailAddress,
      automationSelected
    } = this.props;
    this.props.setSelectedAutomation(this.state.isChecked || automationSelected);
    if (!emailAddress && isAllowCustomEmailInput) {
      setShownStep(EMAIL_INPUT_STEP);
    } else {
      setShownStep(CONNECT_INBOX_STEP);
    }
  }
  renderFeatureList() {
    return /*#__PURE__*/_jsxs(List, {
      children: [/*#__PURE__*/_jsx(ListItem, {
        marginBlock: "200",
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          children: [/*#__PURE__*/_jsx(IconHolder, {
            icon: "success",
            marginInlineEnd: "200"
          }), /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: `${LANG_ROUTE}.bullet1`
          })]
        })
      }), /*#__PURE__*/_jsx(ListItem, {
        marginBlock: "200",
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          children: [/*#__PURE__*/_jsx(IconHolder, {
            icon: "success",
            marginInlineEnd: "200"
          }), /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: `${LANG_ROUTE}.bullet2`
          })]
        })
      }), /*#__PURE__*/_jsx(ListItem, {
        marginBlock: "200",
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          children: [/*#__PURE__*/_jsx(IconHolder, {
            icon: "success",
            marginInlineEnd: "200"
          }), /*#__PURE__*/_jsxs(View, {
            children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: `${LANG_ROUTE}.bullet3`
            }), /*#__PURE__*/_jsx(Text, {
              as: "p",
              marginBlock: "0",
              children: /*#__PURE__*/_jsx(Text, {
                use: "help",
                children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
                  message: `${LANG_ROUTE}.microcopy`
                })
              })
            })]
          })]
        })
      })]
    });
  }
  render() {
    return /*#__PURE__*/_jsx(Flex, {
      "data-selenium": "opt-into-automation-step",
      minBlockSize: "325px",
      textAlign: "start",
      children: /*#__PURE__*/_jsxs(View, {
        children: [/*#__PURE__*/_jsxs(MediaObject, {
          align: "center",
          itemRight: /*#__PURE__*/_jsx(Illustration, {
            marginInlineEnd: "50px",
            name: "successful-send",
            width: 110
          }),
          spacing: "medium",
          children: [/*#__PURE__*/_jsx(Text, {
            as: "h2",
            marginBlockEnd: "800",
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: `${LANG_ROUTE}.title`
            })
          }), this.renderFeatureList()]
        }), /*#__PURE__*/_jsx(HR, {}), /*#__PURE__*/_jsxs(Checkbox, {
          checked: this.state.isChecked,
          onChange: ({
            target: {
              checked
            }
          }) => {
            this.setState({
              isChecked: checked
            });
          },
          children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: `${LANG_ROUTE}.setting`
          }), /*#__PURE__*/_jsx(Text, {
            as: "p",
            marginBlockStart: "100",
            marginBlockEnd: "0",
            children: /*#__PURE__*/_jsx(Text, {
              use: "help",
              children: /*#__PURE__*/_jsx(Link, {
                external: true,
                href: "https://knowledge.hubspot.com/email-tracking/connected-inbox-automation",
                children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
                  message: `${LANG_ROUTE}.learnMore`
                })
              })
            })
          })]
        }), /*#__PURE__*/_jsx(Button, {
          marginBlockStart: "600",
          use: "primary",
          onClick: () => this.handleButtonClick(),
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: `${LANG_ROUTE}.button`
          })
        })]
      })
    });
  }
}
OptIntoAutomationStep.propTypes = StepInterface;
export default OptIntoAutomationStep;